// import { HTTP } from "@ionic-native/http";
// import { Network } from "@capacitor/network";
import { URL_PREFIX } from "../utils/apiUrl";
const env = {
  production: process.env.NODE_ENV === "production",
  baseurl: process.env.REACT_APP_API_URL,
};
import * as dbservice from './database.service.js';
import * as storage from '../utils/storage.js';
import { emptyAuthObj, setAuthObj } from "../utils/authutil";
import axios from 'axios'

const DEBUG_ENABLE = env.production ? false : true;
const DEBUG_URL = "?XDEBUG_SESSION_START=ECLIPSE_DBGP&KEY=16267650893824";
const REQUEST_TIME_OUT_ERROR = "Request timed out";
const NO_HOST_RESOLVED_ERROR = "Host could not be resolved";
const EXPIRED_TOKEN_CODE = 401;
const APPLICATION_ID = "PHOTO_UPLOADER_APP_HTML";

const avoidRefreshMethods = [
  'log_out', 'refresh_token'
];

function shouldRefreshToken(url) {
  const tmp = avoidRefreshMethods.filter(elm => url.includes(elm));
  return tmp.length === 0;
}

export const sendGetRequest = async (url, params = {}) => {
  if (DEBUG_ENABLE) {
    url += DEBUG_URL;
  }
  // HTTP.setDataSerializer("json");
  // HTTP.setRequestTimeout(REQUST_TIME_OUT_IN_SECONDS);
  const value = storage.get(storage.KEYS.LOGIN_TOKEN);
  return new Promise((resolved, reject) => {
    axios.get(env.baseurl + '/' + url, {
      method: "GET",
      url: env.baseurl + '/' + url,
      headers: {
        'Content-Type': 'application/json',
        Authorization: "Bearer " + value
      },
      params,
    }).then(async (res) => {
      console.log({ url, res })
      resolved(res.data);
    }).catch((err) => {
      console.log({ err });
      console.error(url, err);
      if (err.response.status === EXPIRED_TOKEN_CODE && shouldRefreshToken(url)) {
        _handleGetRequestExpiredToken(url, params, resolved);
      } else {
        reject(err);
      }

    });
  });
};

function _handleGetRequestExpiredToken(url, params, resolved) {
  refreshToken({}).then(async (tokenResult) => {
    const payload = tokenResult.response.result;
    setAuthObj(payload);
    const result = await sendGetRequest(url, params);
    resolved(result);

  }).catch(async (error) => {
    console.error(error);
    await logOut({});
    emptyAuthObj();
    window.location.href = '/photos';
  });
}

const sendPostRequest = async (url, body = {}) => {
  if (DEBUG_ENABLE) {
    url += DEBUG_URL;
  }
  // HTTP.setDataSerializer("json");
  // HTTP.setRequestTimeout(REQUST_TIME_OUT_IN_SECONDS);
  const value = storage.get(storage.KEYS.LOGIN_TOKEN);
  return new Promise((resolved, reject) => {
    axios.post(env.baseurl + '/' + url, body, {
      method: "POST",
      url: env.baseurl + '/' + url,
      headers: {
        'Content-Type': 'application/json',
        Authorization: "Bearer " + value
      },
      // data: body,
    }).then((res) => {
      console.log({ url, res })
      resolved(res.data);

    }).catch((err) => {
      console.error(url, err);
      if (err.response.status === EXPIRED_TOKEN_CODE && shouldRefreshToken(url)) {
        _handlePostRequestExpiredToken(url, body, resolved);
      } else {
        reject(err);
      }
    });
  });
};

function _handlePostRequestExpiredToken(url, body, resolved) {
  refreshToken({}).then(async (tokenResult) => {
    const payload = tokenResult.response.result;
    setAuthObj(payload);
    const result = await sendPostRequest(url, body);
    resolved(result);

  }).catch(async (error) => {
    console.error(error);
    await logOut({});
    emptyAuthObj();
    window.location.href = '/photoapp/photos';
  });
}

export const authenticateUser = async (body) => {
  body.device_id = storage.get(storage.KEYS.DEVICE_ID_KEY);
  return await sendPostRequest(URL_PREFIX.AUTHENTICATE_USER, body);
};

export const authenticateToken = async (body) => {
  body.device_id = storage.get(storage.KEYS.DEVICE_ID_KEY);
  return await sendPostRequest(URL_PREFIX.AUTHENTICATE_TOKEN, body);
};

export const itsMe = async (body) => {
  body.application_id = APPLICATION_ID;
  return await sendPostRequest(URL_PREFIX.ITS_ME, body);
};

export const refreshToken = async (body, shouldRedirectLogin = true) => {
  body.application_id = APPLICATION_ID;
  let auth = await storage.get(storage.KEYS.AUTH_OBJ);
  if (auth) {
    auth = JSON.parse(auth);
    body.user_id = auth.user.id;
  } else if (shouldRedirectLogin) {
    window.location.href = '/photos';
  }
  body.device_id = storage.get(storage.KEYS.DEVICE_ID_KEY);
  console.log({ refreshBody: body })
  return await sendPostRequest(URL_PREFIX.REFRESH_TOKEN, body);
};

export const logOut = async (body) => {
  body.application_id = APPLICATION_ID;
  let auth = await storage.get(storage.KEYS.AUTH_OBJ);
  if (auth) {
    auth = JSON.parse(auth);
    body.user_id = auth.user.id;
  }
  body.device_id = storage.get(storage.KEYS.DEVICE_ID_KEY);
  return await sendPostRequest(URL_PREFIX.LOG_OUT, body);
};

export const uploadImages = async (body) => {
  try {
    return await sendPostRequest(URL_PREFIX.UPLOAD_MEDIA, body);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const loadSettings = async () => {
  try {
    const status = await Network.getStatus();
    const lastSettingsUpdateTs = await dbservice.getSavedSetting("lastUpdatedTs");
    const now = new Date().getTime();
    // re-sync settings if saved settings are older than 1 day
    if ((now - lastSettingsUpdateTs) > 60000 * 60 * 24) {
      if (status.connected) {
        const res = await sendGetRequest(URL_PREFIX.GET_SETTINGS);
        const data = res.response.result.data;
        await dbservice.saveOrUpdateSettings(data);
      }
    }
  } catch (error) {
    console.error(error);
  }
  const result = await dbservice.getAllSavedSettings();
  // DataActions.setAppSettings(dispatch, result);
  return result;
};

export const getUploadedMedia = async (body) => {
  return await sendGetRequest(URL_PREFIX.GET_UPLOADED_MEDIA, body);
}
